<template>
    <front-layout title="Candidatos">
        <div class="fixed top-0 left-0 w-full min-h-full block bg-opacity-80 z-50 bg-gray-900 pointer-events-none" v-if="showForm"></div>
        
            <div class="container px-4 pt-40 pb-20 mx-auto">
                <div class="flex flex-col md:flex-row md:space-x-10 items-center mi-h-[80vh]">
                    <div class="flex-1">
                        <img src="/images/about_img_1.png" alt="imagem" class="w-full">
                    </div>

                    <div class="flex-1">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" v-html="candidatos_text_1" id="candidatos_text_1" class="bg-white inline-block p-2 rounded-lg text-lg">
                        </div>

                        <div v-else v-html="candidatos_text_1" class="text-lg"></div>

                        <jet-button @click.prevent="showForm = true" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent focus:ring-violet-500 mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Formulário de inscrição <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></jet-button>
                   
                    </div>
                </div>

                 <div class="flex flex-col md:flex-row md:space-x-10 items-center mi-h-[80vh] mt-8 lg:mt-0">
                    <div class="flex-1">
                        <div class="flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-if="$page.props.user && enableEdit == true" contenteditable @focusout="updateText" v-html="candidatos_text_2" id="candidatos_text_2" class="bg-white inline-block p-2 rounded-lg text-lg">
                        </div>

                        <div v-else v-html="candidatos_text_2" class="text-lg"></div>

                     
                    </div>
                    <div class="flex-1">
                        <img src="/images/about_img_2.png" alt="imagem" class="w-full">
                    </div>
                </div>
            </div>

               <!-- form -->
                <div class="border fixed top-0 right-0 bg-white p-6 shadow-xl z-50 overflow-y-auto transition-all h-full w-full lg:w-1/2" :class="showForm ? 'right-0' : '-right-[100vw]'">
                      
                    <h3 class="font-bold uppercase">Este formulário serve de inscrição</h3>
                    <p class="text-violet-500 text-sm my-2">Todos os campos são de preenchimento obrigatório.</p>

                
                    <form @submitted="createCandidato" class="w-full border-t pt-8 overflow-y-auto">
                        <!-- Nome -->
                        <div>
                            <div class="flex flex-row space-x-2">
                                <jet-label for="nome" value="Nome Completo" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.nome" />
                            </div>
                           
                            <jet-input type="text" v-model="form.nome" class="w-full"/>
                        </div>

                        <div class="flex space-x-4 w-full mt-2">
                            <!-- Documento ident. -->
                            <div class="flex-1">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="doc_tipo" value="Documento de identificação" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.doc_tipo" />
                                </div>
                                <select-input name="form.doc_tipo" v-model="form.doc_tipo" label="">
                                    <option value="" disabled>Documento</option>
                                    <option value="Cartão de Cidadão">Cartão de Cidadão</option>
                                    <option value="Título de Residência">Título de Residência</option>
                                    <option value="Manifestação de Interesse">Manifestação de Interesse</option>
                                    <option value="Passaporte">Passaporte</option>
                                </select-input>   
                            </div>
                            <!-- doc_num -->
                            <div class="flex-1">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="doc_num" value="Doc. nº" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.doc_num" />
                                </div>
                                <jet-input type="text" v-model="form.doc_num" class="w-full" min="8" max="8"/>
                            </div>
                        </div>

                        <!-- data nasc. - nif -->
                        <div class="mt-2 flex flex-row space-x-2">
                            <!-- nif -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="nif_num" value="NºContribuinte" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.nif_num" />
                                </div>
                                <jet-input type="text" v-model="form.nif_num" class="w-full" max="9"/>
                            </div>
                          
                            <!-- data nac -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="data_nasc" value="Data Nascimento" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.data_nasc" />
                                </div>
                                <jet-input type="date" v-model="form.data_nasc" class="w-full" max="9"/>
                            </div>
                        </div>
                       
                        <!-- Morada -->
                        <div class="mt-2">
                            <div class="flex flex-row space-x-2">
                                <jet-label for="morada" value="Morada" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.morada" />
                            </div>
                            <text-area-input v-model="form.morada" rows="2" class="w-full"></text-area-input>
                        </div>
                        <div class="flex space-x-4 w-full mt-2">
                            <!-- Cod postal -->
                            <div class="flex-2">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="cod_postal" value="Cód. Postal" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.cod_postal" />
                                </div>
                                <jet-input type="text" v-model="form.cod_postal" class="w-full" placeholder="0000-000"/>
                            </div>
                            <div class="flex-auto">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="localidade" value="Localidade" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.localidade" />
                                </div>
                                <jet-input type="text" v-model="form.localidade" class="w-full"/>
                            </div>
                        </div>

                        <div class="flex space-x-4 w-full mt-2">
                            <!-- Telefone -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="tel" value="Tel" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.tel" />
                                </div>
                                <jet-input type="text" v-model="form.tel" class="w-full"/>
                                
                            </div>
                            <!-- Email -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="email" value="Email" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.email" />
                                </div>
                                <jet-input type="text" v-model="form.email" class="w-full"/>
                            </div>
                        </div>
                        <!-- Habilitações -->
                        <div class="mt-2">
                            <div class="flex flex-row space-x-2">
                                <jet-label for="habilitacoes" value="Habilitações Literárias" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.habilitacoes" />
                            </div>
                             <select-input name="form.habilitacoes" v-model="form.habilitacoes" label="">
                                <option value="" disabled>Habilitações Literárias</option>
                                <option value="Menos de 4 anos de Escolaridade">MENOS DE 4 ANOS DE ESCOLARIDADE</option>
                                <option value="4 anos de escolaridade (1.º ciclo do ensino básico)">4 ANOS DE ESCOLARIDADE (1.º ciclo do ensino básico)</option>
                                <option value="6 anos de escolaridade (2.º ciclo do ensino básico)">6 ANOS DE ESCOLARIDADE (2.º ciclo do ensino básico)</option>
                                <option value="9º ano  (3.º ciclo do ensino básico)">9.º ANO (3.º ciclo do ensino básico)</option>
                                <option value="11º ano">11.º ANO</option>
                                <option value="12º ano (ensino secundário)">12.º ANO (ensino secundário)</option>
                                <option value="Curso tecnológico (Nível III)">CURSO TECNOLÓGICO/PROFISSIONAL/OUTROS (Nível III)</option>
                                <option value="Bacharelato">BACHARELATO</option>
                                <option value="Licenciatura">LICENCIATURA</option>
                                <option value="Pós-graduação">PÓS-GRADUAÇÃO</option>
                                <option value="Mestrado">MESTRADO</option>
                                <option value="Doutoramento">DOUTORAMENTO</option>
                                <option value="Curso de especialização tecnológica">CURSO DE ESPECIALIZAÇÃO TECNOLÓGICA</option>
                                <option value="Habilitação ignorada">HABILITAÇÃO IGNORADA</option>
                            </select-input>   
                        </div>
                        <!-- tipo trabalho -->
                        <div class="w-full mt-2">
                            <div class="flex flex-row space-x-2">
                                <jet-label for="tipo_trabalho" value="Tipo de trabalho" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.tipo_trabalho" />
                            </div>
                            <jet-input type="text" v-model="form.tipo_trabalho" class="w-full" placeholder="ex: Restauração, Fabril, Administrativo, Indiferente, ..."/>  
                        </div>

                      
                            <!-- Horario -->
                            <div class="flex flex-col md:flex-row md:space-x-2 w-full mt-2 space-y-2 md:space-y-0">
                                <div class="w-full md:w-1/3">
                                    <div class="flex flex-row">
                                        <jet-label for="horario" value="Horario pretendido" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.horario" />
                                    </div>
                               
                               
                                    <select-input name="form.horario" v-model="form.horario" label="">
                                        <option value="" disabled>Preferência</option>
                                        <option value="Diurno">Diurno</option>
                                        <option value="Turnos Semanais">Turnos Semanais</option>
                                         <option value="Turnos Rotativos">Turnos Rotativos</option>
                                        <option value="Part-time">Part-time</option>
                                        <option value="Indiferente">Indiferente</option>
                                    </select-input>
                                </div>
                                
                                <div v-show="form.horario == 'Part-time'" class="w-full md:w-1/3">
                                    <div class="flex flex-row md:space-x-2">
                                        <jet-label for="horario_alt" value="Horário Part-Time" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.horario_alt" />
                                    </div>
                                   
                                    <div>
                                        <select-input name="form.horario_alt" v-model="form.horario_alt" label="">
                                            <option value="" disabled>Preferência</option>
                                            <option value="Manhã">Manhã</option>
                                            <option value="Tarde">Tarde</option>
                                            <option value="Outro">Outro</option>
                                        </select-input>
                                    </div>
                                </div>

                                 <div v-show="form.horario_alt == 'Outro'" class="w-full md:w-1/3">
                                        <jet-label for="form.intervalo" value="Intervalo de horário" class="font-bold text-xs" />
                                        <jet-input type="text" v-model="form.intervalo"  placeholder="das 19h às 06h" class="w-full"/>
                                        <jet-input-error :message="form.errors.intervalo" />
                                    </div>
                            </div>
                  
                     

                        <div class="flex space-x-4 w-full mt-2">
                            <!-- Transporte -->
                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="transporte" value="Meio de Transporte" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.transporte" />
                                </div>
                                <div>
                                    <select-input name="form.transporte" v-model="form.transporte" label="">
                                        <option value="" disabled>Preferência</option>
                                        <option value="A pé">A pé</option>
                                        <option value="Autocarro">Autocarro</option>
                                        <option value="Carro">Carro</option>
                                        <option value="Bicicleta">Bicicleta</option>
                                        <option value="Boleia">Boleia</option>
                                    </select-input>
                                </div>
                            </div>

                            <div class="w-full">
                                <div class="flex flex-row space-x-2">
                                    <jet-label for="zona" value="Zona de Preferência" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.zona" />
                                </div>
                                <div>
                                    <select-input name="form.zona" v-model="form.zona" label="">
                                        <option value="" disabled>Concelho</option>
                                        <option value="Alcobaça">Alcobaça</option>
                                        <option value="Alvaiázere">Alvaiázere</option>
                                        <option value="Ansião">Ansião</option>
                                        <option value="Batalha">Batalha</option>
                                        <option value="Bombarral">Bombarral</option>
                                        <option value="Caldas da Rainha">Caldas da Rainha</option>
                                        <option value="Castanheira de Pêra">Castanheira de Pêra</option>
                                        <option value="Figueiró dos Vinhos">Figueiró dos Vinhos</option>
                                        <option value="Leiria">Leiria</option>
                                        <option value="Marinha Grande">Marinha Grande</option>
                                        <option value="Nazaré">Nazaré</option>
                                        <option value="Óbidos">Óbidos</option>
                                        <option value="Pedrógão Grande">Pedrógão Grande</option>
                                        <option value="Peniche">Peniche</option>
                                        <option value="Pombal">Pombal</option>
                                        <option value="Porto de Mós">Porto de Mós</option>
                                    </select-input>
                                </div>
                            </div>
                        </div>
                        <!-- Experiencia profissional -->
                        <div class="mt-2">
                            <div class="flex flex-row space-x-2">
                                <jet-label for="exp_pro" value="Experiência profissional" class="font-bold text-xs" />
                                <jet-input-error :message="form.errors.exp_pro" />
                            </div>
                            <text-area-input v-model="form.exp_pro" rows="2" class="w-full" placeholder="Empresa, Função, Anos/Meses"></text-area-input>
                            
                        </div>
                        <!-- disponibilidade -->
                        <div class="mt-2 flex flex-row space-x-2">
                            <div class="flex-1">
                                <div class="flex flex-row space-x-2 items-center">
                                    <jet-label for="disponibilidade" value="Disponibilidade imediata?" class="font-bold text-xs" />
                                    <jet-input-error :message="form.errors.disponibilidade" />
                                </div>
                                <select-input name="form.disponibilidade" v-model="form.disponibilidade" label="">
                                    <option value="Sim">Sim</option>
                                    <option value="Não">Não</option>
                                </select-input>
                            </div>
                            <div class="flex-1">
                                 <div v-show="form.disponibilidade == 'Não'">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="disponibilidade_alt" value="Outra" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.disponibilidade_alt" />
                                    </div>
                                    <jet-input type="text" v-model="form.disponibilidade_alt" class="w-full" placeholder="ex: a partir do dia ..."/>
                                </div>
                            </div>
                        </div>

                        <!-- Curriculo -->
                        <div class="mt-2">
                            <jet-label for="file" value="Carregar Currículo(pdf)" class="font-bold text-xs" />
                            <jet-input type="file" ref="curriculo" multiple  @change="getFile" />
                        </div>
                    </form>
               

                    <div class="lg:mt-8 lg:flex items-center">
                        <div>
                            <jet-checkbox v-model="form.rgpd" class="mr-2" value=""></jet-checkbox> Li e aceito a <a :href="route('pol_privacidade')" class="text-violet-500 underline">Política de Privacidade</a>
                            <jet-input-error :message="form.errors.rgpd" />

                        </div>
                        <div class="flex flex-row justify-end flex-1">
                            <jet-secondary-button @click="cancel">Cancelar</jet-secondary-button>

                            <jet-button @click.prevent="createCandidato" class="ml-2 bg-violet-500 hover:bg-violet-600">Enviar</jet-button>
                        </div>
                    </div>
                </div>
     
    </front-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'

    import JetButton from '@/Jetstream/Button.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import SelectInput from '@/Components/SelectInput'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon,
            JetButton,
            JetModal,
            JetDialogModal,
            FrontLayout,
            JetInput,
            JetSecondaryButton,
            JetFormMain,
            JetLabel,
            JetInputError,
            TextAreaInput,
            SelectInput,
            JetCheckbox,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            candidatos_text_1: String,
            candidatos_text_2: String
        },
        data() {
            return {
                enableEdit: false,
                page: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                }),
                showForm: false,
                form: this.$inertia.form({
                    nome: '',
                    doc_tipo: '',
                    doc_num: '',
                    nif_num: '',
                    data_nasc: '',
                    morada: '',
                    localidade: '',
                    cod_postal: '',
                    tel: '',
                    email: '',
                    habilitacoes: '',
                    tipo_trabalho: '',
                    horario: '',
                    horario_alt: '',
                    intervalo: '',
                    transporte: '',
                    zona: '',
                    exp_pro: '',
                    notas: '',
                    disponibilidade: '',
                    disponibilidade_alt: '',
                    curriculo: null,
                    rgpd: '',
                }),
            }
        },
        created(){
            
        },
        methods: {
            updateText(e) {
                this.page.setting = e.target.id
                this.page.content = e.target.innerHTML
                this.page.route = this.route().current()
            },
            updateSettings(e) {
                if(this.page.setting != '' && this.page.content != '' & this.page.route != '') {
                    this.page.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
            getFile(event) {
                this.form.curriculo = event.target.files
            },
            createCandidato() {
                this.form.post(route('candidatos.send'), {
                    preserveScroll: true,
                    onSuccess: () => (
                        this.form.reset(),
                        this.showForm = false
                    ),
                }); 
            },
            cancel() {
                this.form.reset()
                this.showForm = false
            }
        },
    })
</script>
